export enum RepositoryType {
    Local = 0,
    ObjectStorage = 1,
    ArchiveObjectStorage = 2
}
